export default __webpack_public_path__ + "static/media/f4445d05d9552ffe3bea669323b2c9a3.svg";